import LinkTasksIcon from '@/components/ui/icons/LinkTasksIcon'
import TotalOrdersIcon from '@/components/ui/icons/TotalOrdersIcon'
import { useTotalMedicationRequests } from '@/services/dashboard'
import { useLinkCandidatesQuery, useMergeCandidatesQuery } from '@/services/deduplication'
import { borderRadius, colors, fontSizes, fontWeights, shadows } from '@/theme'
import { Box, Paper, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const cardSx = (clickable: boolean) => ({
  p: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: clickable ? 'pointer' : 'default',
  transition: 'all 0.2s',
  '&:hover': clickable ? { borderColor: colors.border.hover, boxShadow: shadows.hover } : undefined
})

const iconCircleSx = {
  width: '40px',
  height: '40px',
  borderRadius: borderRadius.full,
  bgcolor: colors.grey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0
}

const countBadgeSx = {
  width: '44px',
  height: '44px',
  borderRadius: borderRadius.full,
  bgcolor: colors.text.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0
}

export default function StatsCards() {
  const { data } = useTotalMedicationRequests()

  const { data: mergeResponse, isSuccess: isMergeSuccess } = useMergeCandidatesQuery({
    page: 1,
    perPage: 10,
    sort: 'newest'
  })

  const mergeTotal = mergeResponse?.total || 0

  const { data: linkResponse, isSuccess: isLinkSuccess } = useLinkCandidatesQuery({
    page: 1,
    perPage: 10,
    sort: 'newest'
  })
  const linkTotal = linkResponse?.total || 0

  const isFinished = isMergeSuccess && isLinkSuccess
  const total = isFinished ? mergeTotal + linkTotal : ''

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3 }}>
      <Paper variant='outlined' sx={cardSx(false)}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={iconCircleSx}>
            <TotalOrdersIcon />
          </Box>
          <Box>
            <Typography variant='cardTitle'>Total orders left to review</Typography>
            <Typography
              sx={{
                fontSize: fontSizes.base,
                fontWeight: fontWeights.regular,
                color: colors.brand.primary,
                lineHeight: 1.4
              }}
            >
              (Total orders on ID verified)
            </Typography>
          </Box>
        </Box>
        <Box sx={countBadgeSx}>
          <Typography sx={{ color: colors.text.white, fontSize: fontSizes.lg, fontWeight: fontWeights.bold }}>
            {data?.total}
          </Typography>
        </Box>
      </Paper>

      <Link
        to='/deduplication'
        state={{
          backLabel: 'Back to Dashboard',
          fallbackPath: '/'
        }}
      >
        <Paper variant='outlined' sx={cardSx(true)}>
          <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={iconCircleSx}>
              <LinkTasksIcon />
            </Box>
            <Typography variant='cardTitle'>Duplicate tasks to review</Typography>
          </Box>
          <Box sx={countBadgeSx}>
            <Typography sx={{ color: colors.text.white, fontSize: fontSizes.lg, fontWeight: fontWeights.bold }}>
              {total}
            </Typography>
          </Box>
        </Paper>
      </Link>
    </Box>
  )
}
